import { Col, Row } from "antd";
import { useState } from "react";
import GenderDoughnutChart from "./GenderGraph";
import AgeDoughnutChart from "./AgeGraph";
import SectorDoughnutChart from "./SectorGraph";

const CandidateGraph = ({ data }) => {
    const [height, setHeight] = useState(null);
    return (
        <Row gutter={[8, 8]}>
            <Col xs={24} sm={24} md={24} lg={8} xl={8} >
                <GenderDoughnutChart data={data} setHeight={setHeight} />
            </Col>
            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <AgeDoughnutChart data={data} height={height} />
            </Col>
            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <SectorDoughnutChart data={data} height={height} />
            </Col>
        </Row>
    );
};

export default CandidateGraph;
